module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-bottom-stone-path-background.e27bff43.png";